import dayjs from 'dayjs';
import { Subscription } from '../../../models/subscriptionModels';

export const getFormattedCost = (currency: string, price?: number): string => {
    if (currency && price) {
        const formattedCost = Intl.NumberFormat('en-US', { style: 'currency', currency });
        return price ? formattedCost.format(price) : 'N/A';
    }
    return '';
};

export const partitionSubscriptions = (
    subscriptions: Subscription[]
): { current: Subscription[]; upcoming: Subscription[] } => {
    const today = dayjs().startOf('day');
    const current: Subscription[] = [];
    const upcoming: Subscription[] = [];
    subscriptions.forEach(subscription => {
        const startDate = subscription.subscriptionStartDate;
        if (startDate && dayjs(startDate, 'YYYY-MM-DD').isAfter(today)) {
            upcoming.push(subscription);
        } else {
            current.push(subscription);
        }
    });
    return { current, upcoming };
};

export default getFormattedCost;
